import type { StockControlRow } from '@econtractor/types';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import { ProductTitle } from 'modules/product';

interface StockControlTableRowProps {
    row: StockControlRow;
    onOpen: (row: StockControlRow) => void;
    showCategory: boolean;
    showArticle: boolean;
}

const StockControlTableRow = ({ row, onOpen, showCategory, showArticle }: StockControlTableRowProps) => {
    return (
        <tr>
            <td className="name">
                <ProductTitle
                    product={{
                        ID: row.productId,
                        prodName: row.prodName,
                        prodPhoto: row.prodPhoto,
                        vendorId: row.vendorId,
                        vendorName: row.vendorName,
                    }}
                    onClick={() => onOpen(row)}
                />
            </td>
            {showCategory ? (
                <td className="category">
                    <h6 className="mb-1 text-break text-truncate" title={row.categoryName || ''}>
                        {row.categoryName || '-'}
                    </h6>
                </td>
            ) : null}
            {showArticle ? (
                <td className="article text-truncate">
                    <CopyTextWrapper value={row.prodArticle || ''}>
                        <span title={row.prodArticle}>{row.prodArticle}</span>
                    </CopyTextWrapper>
                </td>
            ) : null}
            <td className="count">
                <span className="text-danger fw-medium">{row.stockCount}</span>
            </td>
        </tr>
    );
};

export default StockControlTableRow;
